import TimeIcon from './images/time.svg?react';
import styles from './index.module.scss';

const SysDestroy = () => {
  return (
    <div className={styles.sysDestroy}>
      <div className={styles.timeIcon}>
        <TimeIcon />
      </div>
      All messages will self-destruct in <span className={styles.time}>1 week, </span>
      whether they’re read or not.
    </div>
  );
};

export default SysDestroy;
